import { Link, router, useLocalSearchParams } from 'expo-router';
import { ComponentPropsWithoutRef } from 'react';
import { Platform } from 'react-native';

import {
  HeaderFrame,
  HeaderIconButton,
  HeaderTitleText,
  IconChevronLeft,
  IconClose,
  Text,
  YStack,
  tokens,
} from '@fhs/ui';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

type GetScreenTitleHeaderOptions = {
  backStyle?: 'back' | 'close' | 'dynamic';
  testID?: string;
  cannotGoBackHref?: ComponentPropsWithoutRef<typeof Link>['href'];
  shouldBackToRoot?: boolean;
  showDivider?: boolean;
  subtitle?: string;
};
export const getScreenTitleHeader =
  (getScreenTitleHeaderOpts?: GetScreenTitleHeaderOptions) =>
  ({
    options,
    navigation,
  }: {
    options: { title?: string };
    navigation: { canGoBack: () => boolean };
  }) => {
    const {
      backStyle = 'dynamic',
      cannotGoBackHref = '/',
      testID,
      shouldBackToRoot = false,
      showDivider = false,
      subtitle,
    } = getScreenTitleHeaderOpts ?? {};
    const canGoBack = navigation.canGoBack();
    const { isFromCart } = useLocalSearchParams<{ isFromCart: string }>();
    const href = canGoBack && !shouldBackToRoot ? '../' : cannotGoBackHref;
    const icon =
      (backStyle === 'dynamic' && canGoBack) || backStyle === 'back' ? (
        <IconChevronLeft testID={testID} />
      ) : (
        <IconClose testID={testID} />
      );

    return (
      <HeaderFrame
        style={{
          borderBottomWidth: showDivider ? 1 : 0,
          borderColor: tokens.colors.$blackOpacity10,
        }}
      >
        <HeaderFrame.Left>
          {options?.title === 'Support' ? (
            <HeaderIconButton
              aria-label="Go back"
              onPress={async () => {
                // checking for web before checking for window
                const isSupportPageWebView =
                  Platform.OS === 'web' &&
                  window &&
                  window?.Pypestream &&
                  window?.Pypestream?.shutdown;
                if (isSupportPageWebView) {
                  // needs time to shutdown before navigation to allow cleanup of the pypestream session
                  window.Pypestream?.shutdown();
                  await new Promise(resolve => setTimeout(resolve, 500));
                }

                router.dismissTo(href);
              }}
            >
              {icon}
            </HeaderIconButton>
          ) : (
            <Link href={isFromCart ? routes.cart : href} asChild dismissTo>
              <HeaderIconButton aria-label="Go back">{icon}</HeaderIconButton>
            </Link>
          )}
        </HeaderFrame.Left>
        <HeaderFrame.Middle>
          <YStack style={{ alignItems: 'center' }}>
            <HeaderTitleText text={options.title ?? ''} />
            {subtitle ? <Text.Paragraph size="sm">{subtitle}</Text.Paragraph> : null}
          </YStack>
        </HeaderFrame.Middle>
        <HeaderFrame.Right />
      </HeaderFrame>
    );
  };
